export default "__VITE_ASSET__DYNyv1pT__"